import styled, { css } from 'styled-components';
import { Drawer } from 'antd';

import Button from '@components/Button';

export const StyledDrawer = styled(Drawer)`
  .setur-drawer-body {
    padding-top: 0;
  }
  .setur-drawer-close {
    font-weight: bold;
    font-size: 23px;
    color: ${({ theme }) => theme.palette.black};
    padding: 15px;
  }

  .setur-drawer-title {
    width: fit-content;
    margin: 0 auto;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    color: ${({ theme }) => theme.palette.darkGrey};
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .setur-drawer-header {
    padding: 10px;
  }

  .location-animation-error {
    margin-top: 15px;
    border: 1px solid ${({ theme }) => theme.palette.primaryBrand};
    animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
  }

  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }
`;

export const ResponsiveSearchDrawerItemContent = styled.div<{
  hasError: boolean;
}>`
  padding: 15px 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid rgba(75, 75, 75, 0.2);

  &.border-bottom-hidden {
    border-bottom: none;
  }

  ${({ hasError }) =>
    hasError &&
    css`
      border: 1px solid ${({ theme }) => theme.palette.primaryBrand};
      animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97);
    `}

  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }
`;

export const ResponsiveSearchDrawerItemText = styled.div`
  margin-right: auto;
  margin-left: 20px;
`;

export const ResponsiveSearchDrawerItemTitle = styled.span<{
  isFilled?: boolean;
}>`
  ${({ isFilled }) =>
    isFilled &&
    css`
      opacity: 0.5;
    `};
  font-size: 12px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const ResponsiveSearchDrawerItemSubtitle = styled.span<{
  isFilled?: boolean;
}>`
  opacity: ${({ isFilled }) => (isFilled ? 1 : 0.5)};
  font-weight: ${({ isFilled }) => (isFilled ? 600 : 'normal')};
  font-size: 16px;
  color: ${({ theme, isFilled }) =>
    isFilled ? theme.palette.darkGrey : theme.palette.matterHorn};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    overflow: hidden;
    display: block;
    width: 230px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

// ==================================================
// ==================================================
// Style The Responsive Search By Location Start's Here
// ==================================================
// ==================================================

export const StyledListingLocationDrawer = styled(Drawer)`
  .setur-drawer-body {
    padding: 0 0;
  }

  .setur-drawer-header {
    display: flex;
  }

  .setur-drawer-title {
    width: fit-content;
    margin: 0 auto;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    color: ${({ theme }) => theme.palette.darkGrey};
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .setur-drawer-close {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .select-content {
    min-width: 100%;
  }

  .select-text-content {
    width: 100%;
  }
  .select-text {
    width: 100%;
  }

  .select-input {
    width: 100%;
  }
`;

export const ResponsiveLocationDrawerContent = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ResponsiveListingSearchLocationSelect = styled.div`
  height: 78px;
  margin: 0 15px 18px 15px;
  border-bottom: 1px solid rgba(75, 75, 75, 0.5);

  & div {
    padding: 0;
  }
`;

export const ResponsiveListingSearchDateRangePicker = styled.div`
  grid-row: 1/2;
  height: 100%;
  margin: 0 15px 0 15px;
  border-bottom: 1px solid rgba(75, 75, 75, 0.5);

  &.select-box-icon {
    display: none;
  }

  & div {
    padding: 0;
  }
`;

export const ResponsiveLocationListItems = styled.div`
  width: 100%;
  height: 100%;
`;

export const ResponsiveLocationItems = styled.div`
  padding: 0 15px;
  width: 100%;
  height: fit-content;
  height: 100%;
  overflow: auto;
  z-index: 999999999;
  transition: all 0.5s;
  flex: 1;
`;

export const ListItemsWrappedByHeader = styled.div`
  max-height: 300px;
  height: fit-content;
  padding: 20px 0;
`;

export const ResponsiveLocationListItem = styled.div`
  display: flex;
  align-items: center;
`;
export const ResponsiveLocationListItemContent = styled(Button)`
  border: none;
  padding: 25px 0;
  background-color: ${({ theme }) => theme.palette.white};
  transition: all 0.4s;
  display: flex;
  align-items: center;
  flex: 1;
  min-height: 44px;
  position: relative;
  &:hover,
  &:focus {
    background: none;
    box-shadow: none;
  }
`;

export const ResponsiveLocationListItemIcon = styled.div`
  margin-right: 12px;
`;

export const ResponsiveLocationListItemText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.matterHorn};
`;

export const ResponsiveLocationListTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const ResponsiveLocationListItemCityText = styled.span`
  font-size: 12px;
  opacity: 0.5;
  color: ${({ theme }) => theme.palette.matterHorn};
`;

// ==================================================
// ==================================================
// Style The Responsive Search By Location End's Here
// ==================================================
// ==================================================

export const ResponsiveSearchDrawerButtonWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 15px;
  box-shadow: 0 10px 40px 0 rgba(58, 58, 58, 0.2);
  background-color: ${({ theme }) => theme.palette.white};
`;

// ==================================================
// ==================================================
// Style The Responsive Search By Date Start's Here
// ==================================================
// ==================================================

export const StyledListingDateDrawer = styled(Drawer)`
  .setur-drawer-body {
    padding: 0;
    position: relative;
  }

  .setur-drawer-title {
    width: fit-content;
    margin: 0 auto;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    color: ${({ theme }) => theme.palette.darkGrey};
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .setur-drawer-close {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .setur-drawer-body > div {
    height: fit-content;
  }
  .select-box-icon {
    display: none;
  }

  .responsive-select-box {
    border-bottom: 1px solid rgba(75, 75, 75, 0.3);
    padding: 5px 0 10px 0;
  }
`;

export const ResponsiveDatePickerSelect = styled.div`
  grid-row: 1/2;
  padding: 15px 0 0 15px;
`;

export const ResponsiveDatePickerWrapper = styled.div`
  position: relative;
  grid-row: 2/3;
  overflow: auto;
`;

// ==================================================
// ==================================================
// Style The Responsive Search By Guests Start's Here
// ==================================================
// ==================================================

export const StyledListingGuestDrawer = styled(Drawer)`
  .setur-drawer-body {
    padding: 0;
  }

  .setur-drawer-title {
    width: fit-content;
    margin: 0 auto;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    color: ${({ theme }) => theme.palette.darkGrey};
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .setur-drawer-close {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .responsive-room-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
  }
`;

export const ResponsiveGuestDrawerContent = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 70px;
  gap: 0px 0px;
`;

export const ResponsiveGuestRooms = styled.div`
  height: 100%;
  overflow: auto;
  padding: 15px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 60px;
  gap: 0px 0px;
`;

export const ResponsiveGuestRoomsList = styled.div`
  grid-row: 1/2;
`;

export const ResponsiveGuestRoomsNew = styled.button`
  grid-row: 2/3;
  background-color: transparent;
  border: none;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  &:focus {
    outline: none;
  }
`;

export const ResponsiveGuestRoomsNewText = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.primaryBrand};
  margin-right: 5px;
`;

export const ResponsiveRoomLabel = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.primaryBrand};

  border-bottom: 2px solid ${({ theme }) => theme.palette.primaryBrand}; ;
`;

export const ResponsiveRoomDeleteButton = styled(Button)`
  border: none;
  display: flex;
  align-items: center;
  background-color: transparent;
  box-shadow: none;
  padding: 0;
`;

export const ResponsiveRoomDeleteLabel = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: rgba(58, 58, 58, 0.75);
  margin-right: 4px;
`;

export const ResponsiveRoomMain = styled.div`
  margin-bottom: 30px;
`;

export const ResponsiveSearchSubmitButtonWrapper = styled.div`
  grid-row: 3/4;
  width: 100%;
  padding: 10px 15px;
  z-index: 9999999999;
  display: flex;
  align-items: center;
`;

export const ResponsiveSearchDrawerButton = styled(Button)`
  width: 100%;
  display: block;
  font-weight: bold;
`;

export const StyledRoomsWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
`;

export const StyledListingGuestRoom = styled.div`
  width: 100%;
  height: auto;
`;
